module.exports = __webpack_public_path__ + "img/All_notifications_black.3528ab41.svg";